<template>
  <b-modal
    id="modal-send-notification"
    :title="$t('Notificar')"
    :ok-title="$t(loading ? 'Enviando notificación' : 'Confirmar')"
    ok-only
    ok-variant="success"
    modal-class="dialog-600"
    centered
    no-close-on-backdrop
    @close="close"
    @ok="ok"
    :ok-disabled="loading"
  >
    <p class="text-center">
      Confirme si desea enviar la notificación por correo del documento
      <b>Nº {{ dataInvoice.invoiceNumber }}</b>
    </p>
    <form-render
      v-if="dataInvoice"
      :form.sync="form"
      :fields="fields"
      @send="sendNotification"
      :key="keyFormRender"
      containerButtonsClass="col-sm-12"
      ref="formSendNotification"
    >
    <template #alert-info v-if="isRestrictedCountry">
      <b-alert variant="primary" class="p-1" show>El texto del cuerpo del mensaje es orientativo y puede variar.</b-alert>
    </template>
    </form-render>

    <div v-if="!dataInvoice">
      <b-skeleton width="30%" />
      <b-skeleton type="input" />
      <b-skeleton width="30%" class="mt-1" />
      <b-skeleton type="input" height="100px" />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'modal-send-notification',
  props: ['dataInvoice', 'company_id', 'country_code'],
  data() {
    return {
      form: {},
      fields: [],
      loading: false,
      keyFormRender: 0,
      notificationTemplate: {}
    }
  },
  computed: {
    isRestrictedCountry() {
      return this.country_code && ['co', 'mx'].includes(this.country_code.toLowerCase())
    }
  },
  watch: {
    dataInvoice() {
      this.setFormData()
      this.keyFormRender++
    }
  },
  mounted() {
    this.seedTemplate()
    this.setInitialData()
  },
  methods: {
    ok(bvModalEvent) {
      this.$refs.formSendNotification.checkForm()
      bvModalEvent.preventDefault()
    },
    setInitialData() {
      this.fields = [
        {
          fieldType: 'FieldInput',
          name: 'new_subject',
          label: 'Asunto',
          containerClass: 'col-sm-12 container-info font-weight-bold',
          validation: this.isRestrictedCountry ? '' : 'required',
          clearable: false,
          disabled: this.isRestrictedCountry
        },
        {
          fieldType: 'FieldTextarea',
          name: 'new_body',
          label: 'Cuerpo',
          containerClass: 'col-sm-12 container-info font-weight-bold',
          validation: this.isRestrictedCountry ? '' : 'required',
          clearable: false,
          rows: 7,
          disabled: this.isRestrictedCountry
        },
        {
          name: 'alert-info',
          useSlot: true,
          containerClass: 'col-sm-12 container-info'
        }
      ]
      if (!this.isRestrictedCountry) this.setFormData()
      this.keyFormRender++
    },
    setFormData() {
      this.form = {
        //new_subject: `Informe detallado de factura Identificador Fiscal. ${this.dataInvoice.taxIdentificationNumber} Documento No. ${this.dataInvoice.invoiceNumber}`,
        //new_body: `Estimados,\n\nEstamos adjuntando detalle de los movimientos correspondientes al mes de ${this.$options.filters.monthName(
        //  this.dataInvoice.issueDate
        //)}, ${this.getYear(this.dataInvoice.issueDate)}`
        new_subject: this.notificationTemplate[this.country_code].new_subject(this.dataInvoice),
        new_body: this.notificationTemplate[this.country_code].new_body(this.dataInvoice)
      }
    },
    getYear(date) {
      const newDate = new Date(date)
      newDate.setMonth(newDate.getMonth() - 1)
      return newDate.getFullYear()
    },
    sendNotification(data) {
      this.loading = true
      const params = {
        company_id: this.company_id,
        invoice_number: encodeURIComponent(this.dataInvoice.invoiceNumber)
      }
      const queryParams = {
      }

      if (!this.isRestrictedCountry) {
        queryParams.new_subject = data.new_subject
        queryParams.new_body = data.new_body
      }

      this.$store.dispatch('fetchServiceStatusOnError', {
        name: 'sendEmailBillingDataCompany',
        queryParams,
        params,
        onSuccess: data => this.onSuccessSendNotification(data),
        onError: err => this.handleNotificationError(err)
      })
    },
    onSuccessSendNotification(data) {
      this.loading = false
      this.$success(this.$t('msg-exito-enviar-notificacion', data.message))
      this.close()
    },
    handleNotificationError(error) {
      this.loading = false
      const { subtitle, detail } = this.handlerStandartError(error)
      this.$alert(`${subtitle}<small>${detail}</small>`, null, 'Error al enviar la notificación')
    },
    close() {
      this.$bvModal.hide('modal-send-notification')
      this.setFormData()
    },
    seedTemplate() {
      const invoiceTemplates = {
        'cl': {
          new_subject: (invoice) =>
            `¡Tu Factura Electrónica de ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} ${this.getYear(invoice.issueDate)} Ya Está Disponible! (N° ${invoice.invoiceNumber})`,
          new_body: (invoice) => `Estimados,

¡Esperamos que estén muy bien!

Les queremos comunicar que la factura y el detalle de los movimientos correspondientes a ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} de ${this.getYear(invoice.issueDate)} de ${invoice.businessName} (RUT: ${invoice.taxIdentificationNumber}) ya han sido emitidos.`},

        'co': {
          new_subject: (invoice) =>
            `¡Tu Factura Electrónica de ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} ${this.getYear(invoice.issueDate)} Ya Está Disponible! (N° ${invoice.invoiceNumber})`,
          new_body: (invoice) => `Estimado/a,

Gracias por confiar en Envíame Colombia S.A.S. Adjunto encontrará su factura ${invoice.invoiceNumber} por un valor de ${invoice.totalParse}, emitida en ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} de ${this.getYear(invoice.issueDate)}.

Por favor, remita el pago a la mayor brevedad posible para evitar suspensión del servicio.

Gracias por elegirnos,
Equipo Envíame Colombia`
        },

        'pe': {
          new_subject: (invoice) =>
            `¡Tu Factura Electrónica de ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} ${this.getYear(invoice.issueDate)} Ya Está Disponible! (N° ${invoice.invoiceNumber})`,
          new_body: (invoice) => `Estimado/a,

Gracias por confiar en Envíame Perú S.A.C. Adjunto encontrará su factura ${invoice.invoiceNumber} por un valor de ${invoice.totalParse}, correspondiente a ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} de ${this.getYear(invoice.issueDate)}.

Le recordamos gestionar el pago con anticipación para evitar afectaciones en su operación.

Saludos cordiales,
Equipo Envíame Perú`
        },

        'mx': {
          new_subject: (invoice) =>
            `¡Tu factura electrónica de ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} ${this.getYear(invoice.issueDate)} Ya está disponible! (N° ${invoice.invoiceNumber})`,
          new_body: (invoice) => `Estimado/a,

Gracias por confiar en Envíame. Adjunto encontrará su factura ${invoice.invoiceNumber} por un valor de ${invoice.totalParse}, emitida en ${this.$options.filters.monthNamePreviousMonth(invoice.issueDate)} de ${this.getYear(invoice.issueDate)}.

Agradecemos su pronta gestión del pago y quedamos atentos a cualquier inquietud.

Atentamente,
Equipo Envíame México`
        }
      }

      this.notificationTemplate = { ...invoiceTemplates }
    }
  }
}
</script>
